import { useCallback, useState } from 'react'
import { Link } from 'react-router-dom'
import { Trans } from '@lingui/react/macro'

import { cn } from '@jotta/utils/css'

import { Button } from '../Buttons/Button/Button'

import { hasConsentableCookies, useCookieDeclarations } from './cookieConsent'
import { CookieConsentModal } from './CookieConsentModal'

export function CookieLinks({ className }: { className?: string }) {
  const cookieConsentOpen = useState(false)
  const [_, setCookieConsentOpen] = cookieConsentOpen
  const openCookieConsent = useCallback(() => {
    setCookieConsentOpen(true)
  }, [setCookieConsentOpen])

  const { data: cookieDeclarations } = useCookieDeclarations()

  return (
    <>
      <Link className={cn('link', className)} to="/cookies">
        <Trans>Cookie Policy</Trans>
      </Link>

      {hasConsentableCookies(cookieDeclarations) && (
        <>
          <CookieConsentModal openState={cookieConsentOpen} />
          <Button
            className={cn('btn btn-link', className)}
            onClick={openCookieConsent}
          >
            <Trans>Cookie Settings</Trans>
          </Button>
        </>
      )}
    </>
  )
}
